import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Mail, CircleHelp, Info, ShieldCheck, AlertOctagonIcon, Rocket, FolderOpen } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import MessagesTab from "./Messages";
import ManageFAQsTab from "./FAQs";
import HelpTopicsTab from "./HelpTopics";
import TermsPoliciesTab from "./Terms";
import UserPrivacySettingsTab from "./UserPrivacySettings";
import ManageAppVersionsTab from "./AppVersion";
import ManageResourcesTab from "./Resources";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

// Main Support and Help Desk Component
const SupportHelpDesk = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Mail} label="Messages" />
          <CustomTab icon={CircleHelp} label="Manage FAQs" />
          <CustomTab icon={Info} label="Help Topics" />
          <CustomTab icon={ShieldCheck} label="Terms and Policies" />
          <CustomTab icon={FolderOpen} label="Uploads/Resources" />
          <CustomTab icon={AlertOctagonIcon} label="User Privacy Settings" />
          <CustomTab icon={Rocket} label="Application Versions" />
        </TabList>

        <TabPanels>
          {/* Messages Tab */}
          <TabPanel>
            <MessagesTab />
          </TabPanel>

          {/* Manage FAQs Tab */}
          <TabPanel>
            <ManageFAQsTab />
          </TabPanel>

          {/* Help Topics Tab */}
          <TabPanel>
            <HelpTopicsTab />
          </TabPanel>

          {/* Terms and Policies Tab */}
          <TabPanel>
            <TermsPoliciesTab />
          </TabPanel>

          {/* Resources Tab */}
          <TabPanel>
            <ManageResourcesTab />
          </TabPanel>

          {/* Privacy Settings Tab */}
          <TabPanel>
            <UserPrivacySettingsTab />
          </TabPanel>

          {/* App versions Tab */}
          <TabPanel>
            <ManageAppVersionsTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default SupportHelpDesk;
